import { PIZZA_ASSET_IMAGES } from '../assets/pizzas';

export const PIZZA_EXTRA_GROUPS = [
  {
    id: 'saucen',
    title: 'Saucen ⬇️',
    priceCents: 150,
    options: [
      { id: 'knoblauch-dip', name: 'Knoblauch Dip' },
      { id: 'knoblauchoel-dip', name: 'Knoblauchöl Dip' },
      { id: 'barbecue-dip', name: 'Barbecue Dip' },
      { id: 'tomaten-dip', name: 'Tomaten Dip' },
    ],
  },
  {
    id: 'kaese',
    title: 'Käse je Extra ⬇️',
    priceCents: 200,
    options: [
      { id: 'mozzarella', name: 'Mozzarella' },
      { id: 'mini-mozzarella', name: 'Mini Kugeln Mozzarella' },
      { id: 'gorgonzola', name: 'Gorgonzola' },
      { id: 'parmesan', name: 'Parmesan' },
      { id: 'brie', name: 'Brie Käse' },
      { id: 'bueffelmozzarella', name: 'Büffelmozzarella' },
      { id: 'burrata', name: 'Burrata' },
      { id: 'feta', name: 'Feta Käse' },
    ],
  },
  {
    id: 'fleisch',
    title: 'Fleisch je Extra ⬇️',
    priceCents: 250,
    options: [
      { id: 'haehnchenbrust', name: 'Hähnchenbrust' },
      { id: 'salami', name: 'Salami' },
      { id: 'schinken', name: 'Schinken' },
    ],
  },
  {
    id: 'fisch',
    title: 'Fisch je Extra ⬇️',
    priceCents: 250,
    options: [
      { id: 'thunfisch', name: 'Thunfisch' },
      { id: 'sardellen', name: 'Sardellen' },
      { id: 'garnelen', name: 'Garnelen' },
    ],
  },
  {
    id: 'gemuese',
    title: 'Gemüse je Extra ⬇️',
    priceCents: 150,
    options: [
      { id: 'zwiebeln', name: 'Zwiebeln' },
      { id: 'kirschtomaten', name: 'Kirschtomaten' },
      { id: 'spinat', name: 'Spinat' },
      { id: 'jalapenos', name: 'Jalapeños' },
      { id: 'brokkoli', name: 'Brokkoli' },
      { id: 'kapern', name: 'Kapern' },
      { id: 'paprika', name: 'Paprika' },
      { id: 'champignons', name: 'Champignons' },
      { id: 'mais', name: 'Mais' },
      { id: 'oliven', name: 'Oliven' },
      { id: 'ananas', name: 'Ananas' },
      { id: 'artischocken', name: 'Artischocken' },
      { id: 'tomaten', name: 'Tomaten' },
      { id: 'peperoni', name: 'Peperoni' },
      { id: 'rucola', name: 'Rucola' },
      { id: 'eier', name: 'Eier' },
    ],
  },
];

export const PIZZA_EXTRA_OPTIONS = PIZZA_EXTRA_GROUPS.flatMap((group) =>
  group.options.map((option) => ({
    ...option,
    groupId: group.id,
    groupTitle: group.title,
    priceCents: group.priceCents,
  }))
);

export const SIGNATURE_PIZZAS = [
  {
    id: 'margherita',
    name: 'Margherita',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description: 'Tomatensoße, Mozzarella, Basilikum',
    price: '9,80 EUR',
    badge: 'Nr. 1',
    imageUrl: PIZZA_ASSET_IMAGES.margherita,
    imageAlt: 'Margherita Pizza mit Tomatensoße, Mozzarella und Basilikum',
  },
  {
    id: 'prosciutto',
    name: 'Prosciutto',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description: 'Tomatensoße, Mozzarella, Schinken',
    price: '12,00 EUR',
    badge: 'Nr. 2',
    imageUrl: PIZZA_ASSET_IMAGES.prosciutto,
    imageAlt: 'Prosciutto Pizza mit Tomatensoße, Mozzarella und Schinken',
  },
  {
    id: 'salami',
    name: 'Salami',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description: 'Tomatensoße, Mozzarella, Salami',
    price: '12,00 EUR',
    badge: 'Nr. 3',
    imageUrl: PIZZA_ASSET_IMAGES.salami,
    imageAlt: 'Salami Pizza mit Tomatensoße, Mozzarella und Salami',
  },
  {
    id: 'prosciutto-funghi',
    name: 'Prosciutto e Fungi',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description: 'Tomatensoße, Mozzarella, Schinken, Champignons',
    price: '13,00 EUR',
    badge: 'Nr. 4',
    imageUrl: PIZZA_ASSET_IMAGES.prosciuttoFunghi,
    imageAlt:
      'Prosciutto e Fungi Pizza mit Tomatensoße, Mozzarella, Schinken und Champignons',
  },
  {
    id: 'hawaii',
    name: 'Hawaii',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description: 'Tomatensoße, Mozzarella, Schinken, Ananas',
    price: '13,00 EUR',
    badge: 'Nr. 5',
    imageUrl: PIZZA_ASSET_IMAGES.hawaii,
    imageAlt: 'Hawaii Pizza mit Tomatensoße, Mozzarella, Schinken und Ananas',
  },
  {
    id: 'capricciosa',
    name: 'Capricciosa',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Schinken, Champignons, Artischocken, Oliven',
    price: '13,50 EUR',
    badge: 'Nr. 6',
    imageUrl: PIZZA_ASSET_IMAGES.capricciosa,
    imageAlt:
      'Capricciosa Pizza mit Tomatensoße, Mozzarella, Schinken, Champignons, Artischocken und Oliven',
  },
  {
    id: 'erbacce',
    name: 'Erbacce',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description: 'Tomatensoße, Mozzarella, Gorgonzola, Spinat, Broccoli',
    price: '12,00 EUR',
    badge: 'Nr. 7',
    imageUrl: PIZZA_ASSET_IMAGES.erbacce,
    imageAlt:
      'Erbacce Pizza mit Tomatensoße, Mozzarella, Gorgonzola, Spinat und Broccoli',
  },
  {
    id: 'calzone',
    name: 'Calzone',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, gefüllt mit Schinken, Salami, Champignons',
    price: '13,00 EUR',
    badge: 'Nr. 8',
    imageUrl: PIZZA_ASSET_IMAGES.calzone,
    imageAlt:
      'Calzone mit Tomatensoße, Mozzarella, Schinken, Salami und Champignons',
  },
  {
    id: 'tarantina',
    name: 'Tarantina',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Schinken, Gorgonzola, Zwiebeln, Jalapeños',
    price: '13,00 EUR',
    badge: 'Nr. 9',
    imageUrl: PIZZA_ASSET_IMAGES.tarantina,
    imageAlt:
      'Tarantina Pizza mit Tomatensoße, Mozzarella, Schinken, Gorgonzola, Zwiebeln und Jalapeños',
  },
  {
    id: 'tricolore',
    name: 'Tricolore',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Rucola, Tomatenbruschetta, Parmesan',
    price: '12,50 EUR',
    badge: 'Nr. 10',
    imageUrl: PIZZA_ASSET_IMAGES.tricolore,
    imageAlt:
      'Tricolore Pizza mit Tomatensoße, Mozzarella, Rucola, Tomatenbruschetta und Parmesan',
  },
  {
    id: 'quattro-stagioni',
    name: 'Quattro Stagioni',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Schinken, Salami, Champignons, Artischocken',
    price: '14,00 EUR',
    badge: 'Nr. 11',
    imageUrl: PIZZA_ASSET_IMAGES.quattroStagioni,
    imageAlt:
      'Quattro Stagioni Pizza mit Tomatensoße, Mozzarella, Schinken, Salami, Champignons und Artischocken',
  },
  {
    id: 'quattro-formaggi',
    name: 'Quattro Fromaggi',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description: 'Tomatensoße, Mozzarella, Gorgonzola, Brie Käse, Parmesan',
    price: '13,50 EUR',
    badge: 'Nr. 12',
    imageUrl: PIZZA_ASSET_IMAGES.quattroFormaggi,
    imageAlt:
      'Quattro Fromaggi Pizza mit Tomatensoße, Mozzarella, Gorgonzola, Brie und Parmesan',
  },
  {
    id: 'tonno',
    name: 'Tonno',
    category: 'Pizza Classic',
    allergens: '(4,a,f,m)',
    description: 'Tomatensoße, Mozzarella, Thunfisch, Zwiebeln',
    price: '13,00 EUR',
    badge: 'Nr. 13',
    imageUrl: PIZZA_ASSET_IMAGES.tonno,
    imageAlt: 'Tonno Pizza mit Tomatensoße, Mozzarella, Thunfisch und Zwiebeln',
  },
  {
    id: 'napoli',
    name: 'Napoli',
    category: 'Pizza Classic',
    allergens: '(4,a,f,b,m)',
    description: 'Tomatensoße, Mozzarella, Sardellen, Kapern, Oliven, Oregano',
    price: '13,50 EUR',
    badge: 'Nr. 14',
    imageUrl: PIZZA_ASSET_IMAGES.napoli,
    imageAlt:
      'Napoli Pizza mit Tomatensoße, Mozzarella, Sardellen, Kapern, Oliven und Oregano',
  },
  {
    id: 'gustosa',
    name: 'Gustosa',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Hähnchenbrust, Champignons, Paprika, Zwiebeln',
    price: '13,50 EUR',
    badge: 'Nr. 15',
    imageUrl: PIZZA_ASSET_IMAGES.gustosa,
    imageAlt:
      'Gustosa Pizza mit Tomatensoße, Mozzarella, Hähnchenbrust, Champignons, Paprika und Zwiebeln',
  },
  {
    id: 'montana',
    name: 'Montana',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description: 'Tomatensoße, Mozzarella, Salami, Spinat, Champignons',
    price: '13,00 EUR',
    badge: 'Nr. 16',
    imageUrl: PIZZA_ASSET_IMAGES.montana,
    imageAlt:
      'Montana Pizza mit Tomatensoße, Mozzarella, Salami, Spinat und Champignons',
  },
  {
    id: 'calabrese',
    name: 'Calabrese',
    category: 'Pizza Classic',
    allergens: '(1,4,a,f,m)',
    description:
      'Tomatensoße, Mozzarella, Thunfisch, Gorgonzola, Peperoni, Zwiebeln',
    price: '13,50 EUR',
    badge: 'Nr. 17',
    imageUrl: PIZZA_ASSET_IMAGES.calabrese,
    imageAlt:
      'Calabrese Pizza mit Tomatensoße, Mozzarella, Thunfisch, Gorgonzola, Peperoni und Zwiebeln',
  },
  {
    id: 'rustica',
    name: 'Rustica',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, frische Tomaten, Oliven, Zwiebeln, Oregano, Scharf',
    price: '12,00 EUR',
    badge: 'Nr. 18',
    imageUrl: PIZZA_ASSET_IMAGES.rustica,
    imageAlt:
      'Rustica Pizza mit Tomatensoße, Mozzarella, frischen Tomaten, Oliven, Zwiebeln und Oregano',
  },
  {
    id: 'o-sole-mio',
    name: "O'sole Mio",
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Hähnchenbrust, Mais, Oliven, Kirschtomaten',
    price: '13,50 EUR',
    badge: 'Nr. 19',
    imageUrl: PIZZA_ASSET_IMAGES.oSoleMio,
    imageAlt:
      "O'sole Mio Pizza mit Tomatensoße, Mozzarella, Hähnchenbrust, Mais, Oliven und Kirschtomaten",
  },
  {
    id: 'della-casa',
    name: 'Della Casa',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Schinken, Burrata, Basilikum, Olivenöl, Pesto',
    price: '13,50 EUR',
    badge: 'Nr. 20',
    imageUrl: PIZZA_ASSET_IMAGES.dellaCasa,
    imageAlt:
      'Della Casa Pizza mit Tomatensoße, Mozzarella, Schinken, Burrata, Basilikum, Olivenöl und Pesto',
  },
  {
    id: 'bufalina',
    name: 'Bufalina',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Büffelmozzarella, Pfeffer, Basilikum, Olivenöl',
    price: '13,00 EUR',
    badge: 'Nr. 21',
    imageUrl: PIZZA_ASSET_IMAGES.bufalina,
    imageAlt:
      'Bufalina Pizza mit Tomatensoße, Mozzarella, Büffelmozzarella, Pfeffer, Basilikum und Olivenöl',
  },
  {
    id: 'braccio-di-ferro',
    name: 'Braccio di Ferro',
    category: 'Pizza Classic',
    allergens: '(4,a,c,m)',
    description: 'Tomatensoße, Mozzarella, Spinat, Eier, Knoblauchöl',
    price: '13,00 EUR',
    badge: 'Nr. 22',
    imageUrl: PIZZA_ASSET_IMAGES.braccioDiFerro,
    imageAlt:
      'Braccio di Ferro Pizza mit Tomatensoße, Mozzarella, Spinat, Eiern und Knoblauchöl',
  },
  {
    id: 'vegetaria',
    name: 'Vegetaria Uno',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Spinat, Artischocken, Paprika, Zwiebeln, Champignons, Oliven',
    price: '14,50 EUR',
    badge: 'Nr. 23',
    isVegetarian: true,
    imageUrl: PIZZA_ASSET_IMAGES.vegetaria,
    imageAlt:
      'Vegetaria Uno Pizza mit Tomatensoße, Mozzarella, Spinat, Artischocken, Paprika, Zwiebeln, Champignons und Oliven',
  },
  {
    id: 'gamberoni',
    name: 'Gamberoni',
    category: 'Pizza Classic',
    allergens: '(4,a,b,m)',
    description: 'Tomatensoße, Mozzarella, Garnelen, Kirschtomaten, Petersilie',
    price: '14,00 EUR',
    badge: 'Nr. 24',
    imageUrl: PIZZA_ASSET_IMAGES.gamberoni,
    imageAlt:
      'Gamberoni Pizza mit Tomatensoße, Mozzarella, Garnelen, Kirschtomaten und Petersilie',
  },
  {
    id: 'primavera',
    name: 'Primavera',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Rucola, Kirschtomaten, Oliven, Feta Käse, Pesto',
    price: '13,00 EUR',
    badge: 'Nr. 25',
    imageUrl: PIZZA_ASSET_IMAGES.primavera,
    imageAlt:
      'Primavera Pizza mit Tomatensoße, Mozzarella, Rucola, Kirschtomaten, Oliven, Feta Käse und Pesto',
  },
  {
    id: 'bbq-chicken',
    name: 'BBQ-Chicken',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Barbecuesoße, Mozzarella, Hähnchenbrust, Paprika, Zwiebeln, Scharf',
    price: '13,50 EUR',
    badge: 'Nr. 26',
    imageUrl: PIZZA_ASSET_IMAGES.bbqChicken,
    imageAlt:
      'BBQ-Chicken Pizza mit Barbecue-Soße, Mozzarella, Hähnchenbrust, Paprika und Zwiebeln',
  },
  {
    id: 'mafiosi',
    name: 'Mafiosi',
    category: 'Pizza Classic',
    allergens: '(1,4,a,m)',
    description:
      'Tomatensoße, Mozzarella, Schinken, Salami, Zwiebeln, Peperoni (scharf)',
    price: '14,00 EUR',
    badge: 'Nr. 27',
    imageUrl: PIZZA_ASSET_IMAGES.mafiosi,
    imageAlt:
      'Mafiosi Pizza mit Tomatensoße, Mozzarella, Schinken, Salami, Zwiebeln und Peperoni, scharf',
  },
  {
    id: 'riina',
    name: 'Riina',
    category: 'Pizza Classic',
    allergens: '(1,4,a,c,m)',
    description:
      'Holländische Soße, Mozzarella, Hähnchenbrust, Champignons, Eier, Jalapeños',
    price: '14,00 EUR',
    badge: 'Nr. 28',
    imageUrl: PIZZA_ASSET_IMAGES.riina,
    imageAlt:
      'Riina Pizza mit Holländischer Soße, Mozzarella, Hähnchenbrust, Champignons, Jalapeños und Eiern',
  },
  {
    id: 'milano',
    name: 'Milano',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description:
      'Holländische Soße, Mozzarella, Hähnchenbrust, Brokkoli, Mais, Kirschtomaten, Zwiebeln',
    price: '14,00 EUR',
    badge: 'Nr. 29',
    imageUrl: PIZZA_ASSET_IMAGES.milano,
    imageAlt:
      'Milano Pizza mit Holländischer Soße, Mozzarella, Hähnchenbrust, Brokkoli, Mais, Kirschtomaten und Zwiebeln',
  },
  {
    id: 'zolo',
    name: 'Zola',
    category: 'Pizza Classic',
    allergens: '(4,a,m)',
    description: 'Holländische Soße, Mozzarella, Gorgonzola, Parmesan, Pesto',
    price: '13,50 EUR',
    badge: 'Nr. 30',
    imageUrl: PIZZA_ASSET_IMAGES.zolo,
    imageAlt:
      'Zola Pizza mit Holländischer Soße, Mozzarella, Gorgonzola, Parmesan und Pesto',
  },
  {
    id: 'pizza-brot-rosemary',
    name: 'Rosemary',
    category: 'Pizzeta Pizza Stücke',
    allergens: '(4,a,m)',
    description: 'Pizzabrot, Rosmarin, Olivenöl',
    price: '5,50 EUR',
    badge: 'Nr. 31',
    imageUrl: PIZZA_ASSET_IMAGES.rosemaryKids,
    imageAlt: 'Pizzeta Rosemary mit Pizzabrot, Rosmarin und Olivenöl',
  },
  {
    id: 'pizza-brot-pomodoro',
    name: 'Pomodoro',
    category: 'Pizzeta Pizza Stücke',
    allergens: '(4,a,m)',
    description: 'Pizzabrot mit Tomatenbruschetta, Knoblauchöl, Rosmarin',
    price: '6,80 EUR',
    badge: 'Nr. 32',
    imageUrl: PIZZA_ASSET_IMAGES.pomedoroKids,
    imageAlt:
      'Pizzeta Pomodoro mit Pizzabrot, Tomatenbruschetta, Knoblauchöl und Rosmarin',
  },
  {
    id: 'pizza-brot-formaggio',
    name: 'Formaggio',
    category: 'Pizzeta Pizza Stücke',
    allergens: '(4,a,m)',
    description: 'Pizzabrot mit Mozzarella, Rosmarin, Oregano, Olivenöl',
    price: '7,30 EUR',
    badge: 'Nr. 33',
    imageUrl: PIZZA_ASSET_IMAGES.formaggioKids,
    imageAlt:
      'Pizzeta Formaggio mit Pizzabrot, Mozzarella, Rosmarin, Oregano und Olivenöl',
  },
  {
    id: 'kids-margherita',
    name: 'Magherita',
    category: 'Kinder Pizza',
    allergens: '(4,a,m)',
    description: 'Tomatensoße, Mozzarella',
    price: '7,80 EUR',
    badge: 'Nr. 40',
    imageUrl: PIZZA_ASSET_IMAGES.margaritaKids,
    imageAlt: 'Kinder Pizza Magherita mit Tomatensoße und Mozzarella',
  },
  {
    id: 'kids-prosciutto',
    name: 'Prosciutto',
    category: 'Kinder Pizza',
    allergens: '(1,4,a,m)',
    description: 'Tomatensoße, Mozzarella, Schinken',
    price: '8,80 EUR',
    badge: 'Nr. 41',
    imageUrl: PIZZA_ASSET_IMAGES.prosciuttoKids,
    imageAlt:
      'Kinder Pizza Prosciutto mit Tomatensoße, Mozzarella und Schinken',
  },
  {
    id: 'kids-salami',
    name: 'Salami',
    category: 'Kinder Pizza',
    allergens: '(1,4,a,m)',
    description: 'Tomatensoße, Mozzarella, Salami',
    price: '8,80 EUR',
    badge: 'Nr. 42',
    imageUrl: PIZZA_ASSET_IMAGES.salamiKids,
    imageAlt: 'Kinder Pizza Salami mit Tomatensoße, Mozzarella und Salami',
  },
];

export const OFEN_GEBACKENE_PASTA = [
  {
    id: 'lasagne',
    number: '50',
    name: 'Hausgemachte Lasagne',
    allergens: '(1,4,a,m)',
    price: '12,50 EUR',
  },
  {
    id: 'penne-1',
    number: '51',
    name: 'Penne I',
    allergens: '(1,a,m)',
    description: 'Penne, Mozzarella, Hähnchen, Champignons, Sahne-Tomatensoße',
    price: '14,00 EUR',
  },
  {
    id: 'penne-2',
    number: '51',
    name: 'Penne II',
    allergens: '(4,a,m)',
    description: 'Penne, Mozzarella, Gemüse, Sahne-Tomatensoße',
    price: '12,00 EUR',
  },
  {
    id: 'penne-3',
    number: '52',
    name: 'Penne III',
    allergens: '(4,a,m)',
    description: 'Penne, Mozzarella, Schinken, Champignons, Sahne-Tomatensoße',
    price: '12,00 EUR',
  },
  {
    id: 'penne-4',
    number: '53',
    name: 'Penne IV',
    allergens: '(4,a,m)',
    description: 'Penne, Mozzarella, Spinat, Gorgonzola, Sahne-Soße',
    price: '12,00 EUR',
  },
];

export const BRUSCHETTA_ITEMS = [
  {
    id: 'bruschetta-tomaten',
    number: '80',
    name: 'Bruschetta Tomaten',
    allergens: '(4,a,m)',
    description: '4 Stück geröstete Ciabatta mit Tomatenbruschetta, Oregano',
    price: '6,00 EUR',
  },
  {
    id: 'bruschetta-stracciatella',
    number: '81',
    name: 'Bruschetta Stracciatella',
    allergens: '(4,a,m)',
    description:
      '4 Stück geröstete Ciabatta mit cremiger Burrata, Tomatenbruschetta, Olivenöl, Pfeffer',
    price: '8,00 EUR',
  },
];

export const DRINK_ITEMS = [
  {
    id: 'coca-cola',
    name: 'Coca-Cola',
    price: '2,50 EUR',
  },
  {
    id: 'coca-cola-zero',
    name: 'Coca-Cola Zero',
    price: '2,50 EUR',
  },
  {
    id: 'fanta',
    name: 'Fanta',
    price: '2,50 EUR',
  },
  {
    id: 'apfelschorle',
    name: 'Apfelschorle',
    price: '2,50 EUR',
  },
  {
    id: 'caprisonne',
    name: 'Capri-Sun',
    price: '2,50 EUR',
  },
  {
    id: 'stilles-wasser',
    name: 'Stilles Wasser',
    price: '2,00 EUR',
  },
  {
    id: 'sprudel-wasser',
    name: 'Sprudel Wasser',
    price: '2,00 EUR',
  },
  {
    id: 'san-pellegrino-orange',
    name: 'San Pellegrino Orange',
    price: '2,50 EUR',
  },
  {
    id: 'san-pellegrino-zitrone',
    name: 'San Pellegrino Zitrone',
    price: '2,50 EUR',
  },
];
